module.exports = __webpack_public_path__ + "static/img/map6.81200f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map6.png
// module id = KFVk
// module chunks = 1